import { render, staticRenderFns } from "./btn-whatsapp.vue?vue&type=template&id=2811c49c&scoped=true&"
import script from "./btn-whatsapp.vue?vue&type=script&lang=js&"
export * from "./btn-whatsapp.vue?vue&type=script&lang=js&"
import style0 from "./btn-whatsapp.vue?vue&type=style&index=0&id=2811c49c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2811c49c",
  null
  
)

export default component.exports